module.exports = __webpack_public_path__ + "img/book.a50becfd.svg";